import React, { useState } from 'react';

function LookupForm({ onLookup, loading }) {
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone.length === 10) {
      onLookup(phone);
    }
  };

  const formStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    marginBottom: '20px'
  };

  const inputStyle = {
    padding: '12px',
    fontSize: '18px',
    border: '2px solid #ddd',
    borderRadius: '4px',
    width: '200px',
    marginRight: '10px'
  };

  const buttonStyle = {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: phone.length === 10 && !loading ? 'pointer' : 'not-allowed',
    opacity: phone.length === 10 && !loading ? 1 : 0.6,
    transition: 'all 0.3s ease',
    fontWeight: 'bold'
  };

  return (
    <form onSubmit={handleSubmit} style={formStyle}>
      <h2 style={{ marginTop: 0, color: '#333' }}>Phone Number Lookup</h2>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          style={inputStyle}
          value={phone}
          onChange={e => setPhone(e.target.value.replace(/\D/g, ''))}
          maxLength={10}
          required
          placeholder="Enter 10-digit number"
          disabled={loading}
        />
        <button 
          type="submit" 
          style={buttonStyle}
          disabled={phone.length !== 10 || loading}
        >
          {loading ? 'Looking up...' : 'Lookup'}
        </button>
      </div>
      <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
        Enter phone number without spaces or dashes (e.g., 2015551234)
      </div>
    </form>
  );
}

export default LookupForm; 